import { action, observable, makeObservable } from 'mobx';
import { IPromptProps } from '../type';
import { leaveWithoutSaving } from 'src/utils/modalConfirmations';

export class PromptStore {
  constructor() {
    makeObservable(this);
  }

  @observable public promptProps: IPromptProps | null = null;
  @observable public callBack: ((confirmation: boolean) => void) | null = null;

  @action public promptSwitch = (props: string | null, callBack: ((confirmation: boolean) => void) | null) => {
    this.promptProps = props ? JSON.parse(props) : null;
    this.callBack = callBack;
    if (callBack) this.showMessage();
  };

  @action showMessage = () => {
    const confirm = () => this.callBack && this.callBack(true);
    const cancel = () => this.callBack && this.callBack(false);

    leaveWithoutSaving({ onConfirm: confirm, onCancel: cancel });
  };
}

const promptStore = new PromptStore();

export default promptStore;
